export default function replaceAll(string, replaceTerm, replaceWith) {
  return string.split(replaceTerm).join(replaceWith);
}